import { InputValidationResult, InputValidationResultKind } from "client/Validation";
import { inline } from "client/Validation/rules";
import { IValidationRuleWithBuilder } from "client/Validation/rules/triggers";
import { EMAIL_SEPARATOR } from "./Header/RecipientsAutocomplete";
import { isNotNilOrEmpty } from "client/Misc/utils";
import { localize } from "client_legacy/ndaw/culture";
import { isEmailAddress } from "client_legacy/ndaw/stringFormatValidator";

export const isValidRecipientValue: IValidationRuleWithBuilder<string> = inline(
	(value: string): InputValidationResult => {
		if (!value) {
			return { kind: InputValidationResultKind.Valid };
		}

		const individualRecipients: string[] = value.split(EMAIL_SEPARATOR)
			.map(x => x.trim())
			.filter(isNotNilOrEmpty);

		const isValid: boolean = individualRecipients.every(isEmailAddress);

		if (isValid) {
			return {
				kind: InputValidationResultKind.Valid
			};
		}

		return {
			kind: InputValidationResultKind.Invalid,
			errorMessage: localize("_InvalidEmail")
		};
	}
);
